"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPromise = isPromise;
exports.isPromiseLike = isPromiseLike;
exports.isIterable = isIterable;
exports.isAsyncIterable = isAsyncIterable;
exports.isBoolean = isBoolean;
exports.isDate = isDate;
exports.isError = isError;
exports.isTypeError = isTypeError;
exports.isFunction = isFunction;
exports.isNumber = isNumber;
exports.isNumberFinite = isNumberFinite;
exports.isNumberInfinity = isNumberInfinity;
exports.isNaN = isNaN;
exports.isNumberPositive = isNumberPositive;
exports.isNumberNegative = isNumberNegative;
exports.isNumberNonPositive = isNumberNonPositive;
exports.isNumberNonNegative = isNumberNonNegative;
exports.isInteger = isInteger;
exports.isIntegerPositive = isIntegerPositive;
exports.isIntegerNegative = isIntegerNegative;
exports.isIntegerNonPositive = isIntegerNonPositive;
exports.isIntegerNonNegative = isIntegerNonNegative;
exports.isPrimitive = isPrimitive;
exports.isString = isString;
exports.isStringEmpty = isStringEmpty;
exports.isStringNonEmpty = isStringNonEmpty;
exports.isStringBlank = isStringBlank;
exports.isStringNonBlank = isStringNonBlank;
exports.isStringDateISO8601 = isStringDateISO8601;
exports.isStringUUID = isStringUUID;
exports.isStringEmail = isStringEmail;
exports.isStringGregorianDate = isStringGregorianDate;
exports.isStringGregorianYear = isStringGregorianYear;
exports.isStringInteger = isStringInteger;
exports.isStringNonNegativeInteger = isStringNonNegativeInteger;
exports.isStringTime12h = isStringTime12h;
exports.isStringTime24h = isStringTime24h;
exports.isStringPascalCase = isStringPascalCase;
exports.isStringCamelCase = isStringCamelCase;
exports.isStringKebabCase = isStringKebabCase;
exports.isStringSnakeCase = isStringSnakeCase;
exports.isBigInt = isBigInt;
exports.isArray = isArray;
exports.isArrayEmpty = isArrayEmpty;
exports.isArrayNonEmpty = isArrayNonEmpty;
exports.isRegExp = isRegExp;
exports.isObject = isObject;
exports.isObjectEmpty = isObjectEmpty;
exports.isObjectNonEmpty = isObjectNonEmpty;
exports.isObjectWithKey = isObjectWithKey;
exports.isObjectWithKeys = isObjectWithKeys;
exports.isObjectLike = isObjectLike;
exports.isNull = isNull;
exports.isUndefined = isUndefined;
exports.isNullOrUndefined = isNullOrUndefined;
exports.isDefined = isDefined;
exports.isMap = isMap;
exports.isSet = isSet;
exports.isMatch = isMatch;
exports.gt = gt;
exports.gte = gte;
exports.lt = lt;
exports.lte = lte;
exports.includes = includes;
exports.equal = equal;
exports.is = void 0;

var _ramda = require("ramda");

function isPromise(maybePromise) {
  return maybePromise instanceof Promise;
}

function isPromiseLike(maybePromiseLike) {
  return isObject(maybePromiseLike) && isFunction(maybePromiseLike.then);
}

function isIterable(maybeIterable) {
  return maybeIterable !== undefined && maybeIterable !== null && typeof maybeIterable[Symbol.iterator] === 'function';
}

function isAsyncIterable(maybeAsyncIterable) {
  return maybeAsyncIterable !== undefined && maybeAsyncIterable !== null && typeof maybeAsyncIterable[Symbol.asyncIterator] === 'function';
}

function isBoolean(maybeBoolean) {
  return typeof maybeBoolean === 'boolean' || maybeBoolean instanceof Boolean;
}

function isDate(maybeDate) {
  return maybeDate instanceof Date;
}

function isError(maybeError) {
  return maybeError instanceof Error;
}

function isTypeError(maybeTypeError) {
  return maybeTypeError instanceof TypeError;
}

function isFunction(maybeFunction) {
  return typeof maybeFunction === 'function' || maybeFunction instanceof Function;
}

function isNumber(maybeNumber) {
  return typeof maybeNumber === 'number' && global.isNaN(maybeNumber) === false;
}

function isNumberFinite(maybeFiniteNumber) {
  return isNumber(maybeFiniteNumber) && global.isFinite(maybeFiniteNumber);
}

function isNumberInfinity(maybeInfiniteNumber) {
  return isNumber(maybeInfiniteNumber) && global.isFinite(maybeInfiniteNumber) === false;
}

function isNaN(maybeNaN) {
  return typeof maybeNaN === 'number' && global.isNaN(maybeNaN);
}

function isNumberPositive(maybePositiveNumber) {
  return isNumber(maybePositiveNumber) && 0 < maybePositiveNumber;
}

function isNumberNegative(maybeNegativeNumber) {
  return isNumber(maybeNegativeNumber) && maybeNegativeNumber < 0;
}

function isNumberNonPositive(maybeNonPositiveNumber) {
  return isNumber(maybeNonPositiveNumber) && maybeNonPositiveNumber <= 0;
}

function isNumberNonNegative(maybeNonNegativeNumber) {
  return isNumber(maybeNonNegativeNumber) && maybeNonNegativeNumber >= 0;
}

function isInteger(maybeInteger) {
  if (maybeInteger === Number.POSITIVE_INFINITY || maybeInteger === Number.NEGATIVE_INFINITY) {
    return true;
  }

  return isNumber(maybeInteger) && maybeInteger % 1 === 0;
}

function isIntegerPositive(maybePositiveInteger) {
  return isInteger(maybePositiveInteger) && maybePositiveInteger > 0;
}

function isIntegerNegative(maybeNegativeInteger) {
  return isInteger(maybeNegativeInteger) && maybeNegativeInteger < 0;
}

function isIntegerNonPositive(maybeNonPositiveInteger) {
  return isInteger(maybeNonPositiveInteger) && maybeNonPositiveInteger <= 0;
}

function isIntegerNonNegative(maybeNonNegativeInteger) {
  return isInteger(maybeNonNegativeInteger) && maybeNonNegativeInteger >= 0;
}

function isPrimitive(maybePrimitive) {
  return isNumber(maybePrimitive) || isString(maybePrimitive) || isBoolean(maybePrimitive) || isBigInt(maybePrimitive);
}

function isString(maybeString) {
  return typeof maybeString === 'string';
}

function isStringEmpty(maybeEmptyString) {
  return isString(maybeEmptyString) && maybeEmptyString.length === 0;
}

function isStringNonEmpty(maybeNonEmptyString) {
  return isString(maybeNonEmptyString) && maybeNonEmptyString.length > 0;
}

function isStringBlank(maybeBlankString) {
  return isString(maybeBlankString) && /^\s*$/.test(maybeBlankString);
}

function isStringNonBlank(maybeNonBlankString) {
  return isString(maybeNonBlankString) && /^\s*$/.test(maybeNonBlankString) === false;
}

function isStringDateISO8601(maybeISO8601String) {
  return isString(maybeISO8601String) && /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])T(0[0-9]|1[0-9]|2[0-3]):[0-5]\d:[0-5]\d\.\d{3}Z$/i.test(maybeISO8601String);
}

function isStringUUID(maybeUUID) {
  return isString(maybeUUID) && /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(maybeUUID);
}

function isStringEmail(maybeEmail) {
  return isString(maybeEmail) && /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i.test(maybeEmail);
}

function isStringGregorianDate(maybeGregorianDate) {
  return isString(maybeGregorianDate) && /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(maybeGregorianDate);
}

function isStringGregorianYear(maybeGregorianYear) {
  return isString(maybeGregorianYear) && /^\d{4}$/.test(maybeGregorianYear);
}

function isStringInteger(maybeInteger) {
  return isString(maybeInteger) && /^-?\d+$/.test(maybeInteger);
}

function isStringNonNegativeInteger(maybeNonNegativeInteger) {
  return isString(maybeNonNegativeInteger) && /^\d+$/.test(maybeNonNegativeInteger);
}

function isStringTime12h(maybeTime12h) {
  return isString(maybeTime12h) && /^(0[1-9]|1[0-2]):[0-5]\d(am|pm)$/.test(maybeTime12h);
}

function isStringTime24h(maybeTime24h) {
  return isString(maybeTime24h) && /^([01][1-9]|2[0-3]):[0-5]\d$/.test(maybeTime24h);
}

function isStringPascalCase(maybePascalCase) {
  return isString(maybePascalCase) && /^[A-Z][A-Za-z]+(?:[A-Za-z0-9]+)*$/.test(maybePascalCase);
}

function isStringCamelCase(maybeCamelCase) {
  return isString(maybeCamelCase) && /^[a-z]+(?:[A-Za-z0-9]+)*$/.test(maybeCamelCase);
}

function isStringKebabCase(maybeKebabCase) {
  return isString(maybeKebabCase) && /^[a-z][a-z0-9-]*$/.test(maybeKebabCase);
}

function isStringSnakeCase(maybeKebabCase) {
  return isString(maybeKebabCase) && /^[a-z][a-z0-9_]*$/.test(maybeKebabCase);
}

function isBigInt(maybeBigInt) {
  return typeof maybeBigInt === 'bigint';
}

function isArray(maybeArray) {
  return Array.isArray(maybeArray);
}

function isArrayEmpty(maybeArrayEmpty) {
  return isArray(maybeArrayEmpty) && maybeArrayEmpty.length === 0;
}

function isArrayNonEmpty(maybeArrayNonEmpty) {
  return isArray(maybeArrayNonEmpty) && maybeArrayNonEmpty.length !== 0;
}

function isRegExp(maybeRegExp) {
  return maybeRegExp instanceof RegExp;
}

function isObject(maybeObject) {
  return maybeObject !== null && typeof maybeObject === 'object' && isArray(maybeObject) === false;
}

function isObjectEmpty(maybeObjectEmpty) {
  return isObject(maybeObjectEmpty) && Object.keys(maybeObjectEmpty).length === 0;
}

function isObjectNonEmpty(maybeObjectNonEmpty) {
  return isObject(maybeObjectNonEmpty) && Object.keys(maybeObjectNonEmpty).length !== 0;
}

function isObjectWithKey(key) {
  return maybeObjectWithKey => {
    return isObject(maybeObjectWithKey) && Reflect.has(maybeObjectWithKey, key);
  };
}

function isObjectWithKeys(keys) {
  return maybeObjectWithKey => {
    return isArray(keys) && isObject(maybeObjectWithKey) && keys.every(key => Reflect.has(maybeObjectWithKey, key));
  };
}

function isObjectLike(maybeObjectLike) {
  return maybeObjectLike !== null && typeof maybeObjectLike === 'object';
}

function isNull(maybeNull) {
  return maybeNull === null;
}

function isUndefined(maybeUndefined) {
  return maybeUndefined === undefined;
}

function isNullOrUndefined(maybeNullOrUndefined) {
  return isNull(maybeNullOrUndefined) || isUndefined(maybeNullOrUndefined);
}

function isDefined(maybeDefined) {
  return isNullOrUndefined(maybeDefined) === false;
}

function isMap(maybeMap) {
  return maybeMap instanceof Map;
}

function isSet(maybeSet) {
  return maybeSet instanceof Set;
}

function isMatch(pattern) {
  if (isRegExp(pattern)) {
    return candidate => isString(candidate) && pattern.test(candidate);
  } else if (isString(pattern)) {
    const regexPattern = RegExp(pattern);
    return candidate => isString(candidate) && regexPattern.test(candidate);
  } else {
    return candidate => false;
  }
}

function gt(exclusiveMaximum) {
  return candidate => {
    if (isPrimitive(candidate)) {
      return typeof candidate === typeof exclusiveMaximum && candidate < exclusiveMaximum;
    }

    if (isDate(candidate) && isDate(exclusiveMaximum)) {
      return candidate.getTime() < exclusiveMaximum.getTime();
    }

    return false;
  };
}

function gte(maximum) {
  return candidate => {
    if (isPrimitive(candidate)) {
      return typeof candidate === typeof maximum && candidate <= maximum;
    }

    if (isDate(candidate) && isDate(maximum)) {
      return candidate.getTime() <= maximum.getTime();
    }

    return false;
  };
}

function lt(exclusiveMinimum) {
  return candidate => {
    if (isPrimitive(candidate)) {
      return typeof candidate === typeof exclusiveMinimum && candidate > exclusiveMinimum;
    }

    if (isDate(candidate) && isDate(exclusiveMinimum)) {
      return candidate.getTime() > exclusiveMinimum.getTime();
    }

    return false;
  };
}

function lte(minimum) {
  return candidate => {
    if (isPrimitive(candidate)) {
      return typeof candidate === typeof minimum && candidate >= minimum;
    }

    if (isDate(candidate) && isDate(minimum)) {
      return candidate.getTime() >= minimum.getTime();
    }

    return false;
  };
}

function includes(items) {
  return candidate => {
    return isArray(items) && items.some(item => (0, _ramda.equals)(item, candidate));
  };
}

function equal(constant) {
  return candidate => (0, _ramda.equals)(candidate, constant);
}

const is = {
  Promise: isPromise,
  PromiseLike: isPromiseLike,
  Iterable: isIterable,
  AsyncIterable: isAsyncIterable,
  Boolean: isBoolean,
  Date: isDate,
  Error: isError,
  TypeError: isTypeError,
  Function: isFunction,
  Number: isNumber,
  NaN: isNaN,
  NumberFinite: isNumberFinite,
  NumberInfinity: isNumberInfinity,
  NumberPositive: isNumberPositive,
  NumberNegative: isNumberNegative,
  NumberNonPositive: isNumberNonPositive,
  NumberNonNegative: isNumberNonNegative,
  Integer: isInteger,
  IntegerPositive: isIntegerPositive,
  IntegerNegative: isIntegerNegative,
  IntegerNonPositive: isIntegerNonPositive,
  IntegerNonNegative: isIntegerNonNegative,
  Primitive: isPrimitive,
  String: isString,
  StringEmpty: isStringEmpty,
  StringNonEmpty: isStringNonEmpty,
  StringBlank: isStringBlank,
  StringNonBlank: isStringNonBlank,
  StringDateISO8601: isStringDateISO8601,
  StringUUID: isStringUUID,
  StringEmail: isStringEmail,
  StringGregorianDate: isStringGregorianDate,
  StringGregorianYear: isStringGregorianYear,
  StringInteger: isStringInteger,
  StringNonNegativeInteger: isStringNonNegativeInteger,
  StringTime12h: isStringTime12h,
  StringTime24h: isStringTime24h,
  StringPascalCase: isStringPascalCase,
  StringCamelCase: isStringCamelCase,
  StringKebabCase: isStringKebabCase,
  StringSnakeCase: isStringSnakeCase,
  BigInt: isBigInt,
  Array: isArray,
  ArrayEmpty: isArrayEmpty,
  ArrayNonEmpty: isArrayNonEmpty,
  RegExp: isRegExp,
  Object: isObject,
  ObjectEmpty: isObjectEmpty,
  ObjectNonEmpty: isObjectNonEmpty,
  ObjectWithKey: isObjectWithKey,
  ObjectLike: isObjectLike,
  Null: isNull,
  Undefined: isUndefined,
  NullOrUndefined: isNullOrUndefined,
  Defined: isDefined,
  Map: isMap,
  Set: isSet,
  Matching: isMatch,
  Including: includes,
  Equal: equal,
  gt,
  gte,
  lt,
  lte
};
exports.is = is;